var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWheelV2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1416_5955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3125 0.571533L27.125 6.5436L24.3125 13.3215C21.2189 13.3215 18.4064 14.5872 16.3531 16.6121L9.00617 14.8902L7.40942 7.66841C11.7408 3.33716 17.7312 0.571533 24.3125 0.571533Z",
    fill: "#E64560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2156 7.66841L39.8018 14.7073L32.2719 16.6122C30.2187 14.5872 27.4062 13.3215 24.3125 13.3215V0.571533C30.8938 0.571533 36.8843 3.33716 41.2156 7.66841Z",
    fill: "#66B3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3125 24.5714L42.2059 27.3839L35.5625 24.5714C35.5625 21.4776 34.2969 18.6651 32.272 16.612L41.2157 7.66821C45.5469 11.9995 48.3125 17.9901 48.3125 24.5714Z",
    fill: "#4D88FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3125 24.5715C48.3125 31.1527 45.5469 37.1433 41.2156 41.4747L33.4416 39.3255L32.272 32.5308C34.2969 30.4777 35.5625 27.6652 35.5625 24.5715H48.3125Z",
    fill: "#7ACC52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2156 41.4746C36.8843 45.8059 30.8938 48.5715 24.3125 48.5715L21.5 42.0061L24.3125 35.8215C27.4062 35.8215 30.2187 34.5559 32.272 32.5308L41.2156 41.4746Z",
    fill: "#ADE65C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3125 35.8216V48.5716C17.7312 48.5716 11.7408 45.8059 7.40942 41.4747L9.07321 34.1858L16.3532 32.5308C18.4064 34.5559 21.2189 35.8216 24.3125 35.8216Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.353 32.5308L7.40937 41.4747C3.07812 37.1433 0.3125 31.1527 0.3125 24.5715L7.03569 21.759L13.0625 24.5715C13.0625 27.6652 14.3281 30.4777 16.353 32.5308Z",
    fill: "#FFCB66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.353 16.6121C14.3281 18.6652 13.0625 21.4777 13.0625 24.5716H0.3125C0.3125 17.9902 3.07812 11.9996 7.40937 7.66846L16.353 16.6121Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.8125,
    cy: 24.4016,
    r: 13,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1416_5955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8125 33.4016C29.7831 33.4016 33.8125 29.3722 33.8125 24.4016C33.8125 19.431 29.7831 15.4016 24.8125 15.4016C19.8419 15.4016 15.8125 19.431 15.8125 24.4016C15.8125 29.3722 19.8419 33.4016 24.8125 33.4016Z",
    fill: "#EDF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1875 25.5266H21.4375C21.1391 25.5266 20.853 25.4081 20.642 25.1971C20.431 24.9861 20.3125 24.7 20.3125 24.4016C20.3125 24.1032 20.431 23.8171 20.642 23.6061C20.853 23.3951 21.1391 23.2766 21.4375 23.2766H28.1875C28.4859 23.2766 28.772 23.3951 28.983 23.6061C29.194 23.8171 29.3125 24.1032 29.3125 24.4016C29.3125 24.7 29.194 24.9861 28.983 25.1971C28.772 25.4081 28.4859 25.5266 28.1875 25.5266Z",
    fill: "#9B5AF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8125 28.9016C24.5141 28.9016 24.228 28.7831 24.017 28.5721C23.806 28.3611 23.6875 28.075 23.6875 27.7766V21.0266C23.6875 20.7282 23.806 20.4421 24.017 20.2311C24.228 20.0201 24.5141 19.9016 24.8125 19.9016C25.1109 19.9016 25.397 20.0201 25.608 20.2311C25.819 20.4421 25.9375 20.7282 25.9375 21.0266V27.7766C25.9375 28.075 25.819 28.3611 25.608 28.5721C25.397 28.7831 25.1109 28.9016 24.8125 28.9016Z",
    fill: "#9B5AF8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1416_5955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.3125 0.571533)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1416_5955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(15.8125 15.4016)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWheelV2);
export default __webpack_public_path__ + "static/media/AddWheelV2.7ffe3dd914a02355dbc1558082a2daeb.svg";
export { ForwardRef as ReactComponent };